import { useState } from 'react';
import { MessageSquare, Mail, Smartphone } from 'lucide-react';
import { ReguasPerformanceTable } from '../ReguasPerformanceTable';
import { FunnelChart } from '../FunnelChart';
import { FunnelInsights } from '../FunnelInsights';
import { ReguaSelector } from '../ReguaSelector';
import { getFunnelByRegua, REGUAS } from '@/data/dashboardMockData';

interface StepsStats {
  sms: number;
  email: number;
  whatsapp: number;
}

interface ReguaTabProps {
  stepsStats?: StepsStats;
}

export function ReguaTab({ stepsStats = { sms: 22, email: 12, whatsapp: 9 } }: ReguaTabProps) {
  const [selectedReguaId, setSelectedReguaId] = useState<string>('all');
  
  const funnelData = getFunnelByRegua(selectedReguaId);
  const selectedRegua = REGUAS.find(r => r.id === selectedReguaId);

  return (
    <div className="space-y-6">
      {/* Cards de Steps Ativos por Canal */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="p-4 rounded-2xl border bg-card hover:shadow-lg transition-all duration-300">
          <div className="flex items-center gap-3">
            <div className="p-3 rounded-xl bg-[hsl(280,70%,95%)]">
              <Smartphone className="h-5 w-5 text-[hsl(280,70%,50%)]" />
            </div>
            <div>
              <p className="text-2xl font-bold text-foreground">{stepsStats.sms}</p>
              <p className="text-xs text-muted-foreground">Steps de SMS ativos</p>
            </div>
          </div>
        </div>
        
        <div className="p-4 rounded-2xl border bg-card hover:shadow-lg transition-all duration-300">
          <div className="flex items-center gap-3">
            <div className="p-3 rounded-xl bg-[hsl(220,70%,95%)]">
              <Mail className="h-5 w-5 text-[hsl(220,70%,50%)]" />
            </div>
            <div>
              <p className="text-2xl font-bold text-foreground">{stepsStats.email}</p>
              <p className="text-xs text-muted-foreground">Steps de Email ativos</p>
            </div>
          </div>
        </div>
        
        <div className="p-4 rounded-2xl border bg-card hover:shadow-lg transition-all duration-300">
          <div className="flex items-center gap-3">
            <div className="p-3 rounded-xl bg-[hsl(142,70%,90%)]">
              <MessageSquare className="h-5 w-5 text-[hsl(142,70%,40%)]" />
            </div>
            <div>
              <p className="text-2xl font-bold text-foreground">{stepsStats.whatsapp}</p>
              <p className="text-xs text-muted-foreground">Steps de WhatsApp ativos</p>
            </div>
          </div>
        </div>
      </div>

      {/* Tabela de Performance das Réguas */}
      <ReguasPerformanceTable />

      {/* Funil de Conversão com Seletor + Insights IA */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="p-5 rounded-2xl border bg-card hover:shadow-lg transition-all duration-300 flex flex-col">
          <div className="flex flex-col gap-3 mb-4">
            <div>
              <h3 className="text-sm font-semibold text-foreground">Funil de Conversão</h3>
              <p className="text-xs text-muted-foreground">Eficiência dos canais de cobrança</p>
            </div>
            <ReguaSelector 
              selectedReguaId={selectedReguaId} 
              onSelect={setSelectedReguaId} 
            />
          </div>
          
          <FunnelChart data={funnelData} />
        </div>
        
        {/* Insights IA substituindo Análise do Funil */}
        <FunnelInsights 
          funnelData={funnelData} 
          reguaNome={selectedReguaId === 'all' ? 'Todas as Réguas' : selectedRegua?.nome}
        />
      </div>
    </div>
  );
}
